﻿$.fn.dxCtrlPopupResizeImage = function custom_dxCtrlPopupResizeImage(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlpopupresizeimage");
        this.instance = new cdxCtrlPopupResizeImage(this, option);
    }
    return this;
}

window.cdxCtrlPopupResizeImage = function (container, option) {
    var Me = this;
    if (typeof option.value == 'undefined') option.value = null;          // URL de l'image
    if (typeof option.percent == 'undefined') option.percent = 100;       // 100 = pas de resize
    if (typeof option.jpegQuality == 'undefined') option.jpegQuality = 0.8;
    if (typeof option.onValueChanged != 'function') option.onValueChanged = null;
    if (typeof option.onValidation != 'function') option.onValidation = null;

    var popup = null;
    var $zone, $img, $info, slider;
    var imgEl = null, objectUrl = null;
    var natW = 0, natH = 0, origBytes = 0, mime = 'image/jpeg';
    var estimTimer = null, estimSeq = 0, estimBytes = null;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
            if (name == 'value') mChargeImage();
            if (name == 'percent' && slider) slider.option('value', value);
        }
    }

    this.getResult = function () {
        var t = mTaille();
        return {
            url: option.value, percent: option.percent, width: t.w, height: t.h,
            originalBytes: origBytes, estimatedBytes: estimBytes
        };
    }

    function mTaille() {
        return {
            w: Math.max(1, Math.round(natW * option.percent / 100)),
            h: Math.max(1, Math.round(natH * option.percent / 100))
        };
    }

    function mFormatOctets(n) {
        if (n == null) return '?';
        if (n < 1024) return n + ' o';
        if (n < 1024 * 1024) return (n / 1024).toFixed(1) + ' Ko';
        return (n / 1024 / 1024).toFixed(2) + ' Mo';
    }

    function mAfficheInfo(poidsTexte) {
        if (!$info) return;
        if (!natW) { $info.text(''); return; }
        var t = mTaille();

        // Taille
        var txt = 'Nouvelle taille : <b>' + t.w + ' × ' + t.h + ' px</b>';
        if (option.percent < 100) txt += ' (original ' + natW + ' × ' + natH + ' px)';

        // Poids
        txt += '  —  Nouveau poids : <b>' + poidsTexte + '</b>';
        if (origBytes) {
            txt += ' (original ' + mFormatOctets(origBytes);
            if (estimBytes != null && estimBytes < origBytes) {
                txt += ', soit −' + Math.round((1 - estimBytes / origBytes) * 100) + ' %';
            }
            txt += ')';
        }
        $info.html(txt);
    }

    function mMajAffichage() {
        if (!natW || !$img) return;
        var t = mTaille();
        $img.css({ width: t.w + 'px', height: t.h + 'px' });
        mCentre();
    }

    // Place le centre de l'image au centre de la zone
    function mCentre() {
        if (!$zone) return;
        var z = $zone[0];
        z.scrollLeft = Math.max(0, (z.scrollWidth - z.clientWidth) / 2);
        z.scrollTop = Math.max(0, (z.scrollHeight - z.clientHeight) / 2);
    }

    function mEstimePoids() {
        if (!imgEl || !natW) return;
        clearTimeout(estimTimer);
        mAfficheInfo('estimation…');
        var seq = ++estimSeq;

        estimTimer = setTimeout(function () {
            var t = mTaille();
            var canvas = document.createElement('canvas');
            canvas.width = t.w;
            canvas.height = t.h;
            var ctx = canvas.getContext('2d');
            ctx.imageSmoothingEnabled = true;
            ctx.imageSmoothingQuality = 'high';
            ctx.drawImage(imgEl, 0, 0, t.w, t.h);

            var outMime = (mime == 'image/png') ? 'image/png' : 'image/jpeg';
            try {
                canvas.toBlob(function (blob) {
                    if (seq != estimSeq) return;              // résultat obsolète
                    if (!blob) { mEstimeProportionnelle(); return; }
                    estimBytes = origBytes ? Math.min(blob.size, origBytes) : blob.size;
                    mAfficheInfo('≈ ' + mFormatOctets(estimBytes));
                }, outMime, option.jpegQuality);
            } catch (e) {
                mEstimeProportionnelle();                     // image d'un autre domaine sans CORS
            }
        }, 250);
    }

    function mEstimeProportionnelle() {
        if (!origBytes) { estimBytes = null; mAfficheInfo('poids inconnu'); return; }
        var r = option.percent / 100;
        estimBytes = Math.round(origBytes * r * r);
        mAfficheInfo('≈ ' + mFormatOctets(estimBytes) + ' (approx.)');
    }

    function mChargeImage() {
        if (!$img) return;                                    // popup pas encore construit
        natW = natH = origBytes = 0;
        estimBytes = null;
        imgEl = null;
        if (objectUrl) { URL.revokeObjectURL(objectUrl); objectUrl = null; }
        $img.hide().removeAttr('src');
        mAfficheInfo('');
        if (!option.value) return;

        var surChargement = function () {
            imgEl = $img[0];
            natW = imgEl.naturalWidth;
            natH = imgEl.naturalHeight;
            $img.show();
            mMajAffichage();
            mEstimePoids();
        };

        $.ajax({
            url: option.value,
            method: 'GET',
            cache: true,
            xhrFields: { responseType: 'blob' }
        })
            .done(function (blob) {
                origBytes = blob.size;
                mime = blob.type || 'image/jpeg';
                objectUrl = URL.createObjectURL(blob);
                $img.one('load', surChargement).attr('src', objectUrl);
            })
            .fail(function () {
                mime = /\.png(\?|$)/i.test(option.value) ? 'image/png' : 'image/jpeg';
                $img.attr('crossorigin', 'anonymous')
                    .one('load', surChargement)
                    .attr('src', option.value);
            });
    }

    function mValider() {
        if (!natW) return;                                    // image pas encore chargée
        var t = mTaille();

        option.bddCtrl.mAjaxCall({
            command: "migrein72dpiforemail",
            width_resize: option.percent,
            urlimage: option.value
        }, function (data) {
            if (option.onValidation) option.onValidation(option.value);
            popup.hide();
        });
    }

    function mConstruit() {

        popup = container.appendTo("body").dxCtrlPopupBase({
            width: "90%",
            height: "90%",
            showMaximize: false,
            title:"<div style='line-height:0.6'>Redimensionnez votre image<br/><span style='font-size:50%;'>Adaptez les dimensions en pixels de votre image à la taille à laquelle elle sera affichée dans votre email afin de réduire son poids et d’accélérer son chargement.</span></div>",
            contentTemplate: function (contentElement) {
                contentElement.empty();
                contentElement.css({
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                    "padding-top":"0"
                });

                // Zone image (centrée, scroll si trop grande)
                $zone = $('<div>').css({
                    flex: '1',
                    minHeight: '0',
                    overflow: 'auto',
                    display: 'flex',
                    background: '#f3f3f3',
                    border: theme.border
                }).appendTo(contentElement);

                // Molette : change la taille en % (5 % par cran, 1 % avec Maj)
                $zone[0].addEventListener('wheel', function (e) {
                    if (!natW || !slider) return;
                    e.preventDefault();                           // empêche le défilement de la zone
                    var pas = e.shiftKey ? 1 : 5;
                    var sens = (e.deltaY || e.deltaX) < 0 ? 1 : -1;   // molette vers le haut = agrandir
                    var v = Math.min(100, Math.max(1, option.percent + sens * pas));
                    if (v != option.percent) slider.option('value', v);
                }, { passive: false });

                $img = $('<img alt="">').css({
                    margin: 'auto',
                    display: 'block'
                }).hide().appendTo($zone);

                // Bas : slider + infos
                var $bas = $('<div>').css({
                    padding: '0'
                }).appendTo(contentElement);

                var $slider = $('<div>').appendTo($bas);

                $info = $('<div>').css({
                    textAlign: 'center',
                    fontSize: '12px',
                    color: '#666',
                    marginTop: '6px'
                }).appendTo($bas);

                slider = $slider.dxSlider({
                    min: 1,
                    max: 100,
                    value: option.percent,
                    valueChangeMode: 'onHandleMove',
                    tooltip: {
                        enabled: true,
                        showMode: 'always',
                        position: 'top',
                        format: function (v) { return v + ' %'; }
                    },
                    onValueChanged: function (e) {
                        option.percent = e.value;
                        mMajAffichage();
                        mEstimePoids();
                        if (option.onValueChanged) {
                            var t = mTaille();
                            option.onValueChanged({ percent: e.value, width: t.w, height: t.h });
                        }
                    }
                }).dxSlider('instance');

                mAddButtonOkAnnuler(contentElement,
                    function () { mValider(); },          // ok
                    function () { popup.hide(); },        // annuler
                    "Annuler", "Valider")

                mChargeImage();
            }
        }).dxCtrlPopupBase("instance");

        popup.show();
    }

    mConstruit();
}